import type { SVGProps } from 'react'

const SvgFitPageHeight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' {...props}>
    <path d='M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80zm168-520h144q14 0 19-12t-5-22l-58-58q-12-12-28-12t-28 12l-58 58q-10 10-5 22t19 12m100 332 58-58q10-10 5-22t-19-12H408q-14 0-19 12t5 22l58 58q12 12 28 12t28-12' />
  </svg>
)

export default SvgFitPageHeight
